function Masterpage_form_edit(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    radioSource: '.js-radio-source',
	    containerTemplate: '.js-container-template',
	    containerPage: '.js-container-page',
	    selectTemplate: '.js-select-template',
	    selectPage: '.js-select-page'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded'
    };

    this.classNames = {
	    disabled: 'disabled'
    };

    this.init = function() {
	    this.$radioSource = this.$element.find(this.selectors.radioSource);

	    if (this.$radioSource.length) {

		    this.$radioSourcePage = this.$radioSource.find('input[value=page]');
		    this.$radioSourceTemplate = this.$radioSource.find('input[value=template]');

		    this.$formParent = this.$element.parents(this.selectors.formParent);
		    this.$containerTemplate = this.$element.find(this.selectors.containerTemplate);
		    this.$containerPage = this.$element.find(this.selectors.containerPage);
		    this.$selectTemplate = this.$element.find(this.selectors.selectTemplate);
		    this.$selectPage = this.$element.find(this.selectors.selectPage);

		    this.$radioSource.on('i4:change', this.$onChangeSource.bind(this));

			this.$formParent.on(this.triggers.afterLoaded, (function() {
				this.$onChangeSource();
			}).bind(this));
	    }

    };

    this.$onChangeSource = function() {

	    if (this.$radioSourcePage.is(':checked')) {
			this.$containerPage.show();
			this.$containerTemplate.hide();

			this.$selectTemplate.toggleClass(this.classNames.disabled, true);
			this.$selectPage.toggleClass(this.classNames.disabled, false);

		} else {
			this.$containerPage.hide();
			this.$containerTemplate.show();

			this.$selectTemplate.toggleClass(this.classNames.disabled, false);
			this.$selectPage.toggleClass(this.classNames.disabled, true);
		}
    };
}
